const languages = ['nl', 'fr', 'en', 'de', 'it', 'es'];

export default languages;